import { Component, Input, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { ApplicationContextService, RolePermissionService } from 'lib-core-shared';
import { ControlBaseDirective } from '../../directives/control-base.directive';

@Component({
  selector: 'lib-text-box',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.css']
})
export class TextBoxComponent extends ControlBaseDirective implements AfterViewInit {
  @Input() autofocus?: boolean;
  @Input() additionalText?: string;
  @ViewChild("textInput") inputField?: ElementRef;

  constructor(public roleService: RolePermissionService, public applicationContext: ApplicationContextService) { 
    super(roleService, applicationContext);
  }

  ngAfterViewInit() {
    if (this.autofocus) {
      this.inputField?.nativeElement.focus();
    }
  }
}
